import { stadiumApi, porticoApi } from './axios'
import { decamelizeKeys } from 'humps'

export const fetchMerchants = (venueUuid) =>
  stadiumApi.get('/operator/merchants', {
    params: { venue_uuid: venueUuid },
  })

export const createMerchant = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.post('operator/merchants', params)
}

export const updateMerchant = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.put('operator/merchants', params)
}

export const deleteMerchant = (uuid) =>
  stadiumApi.delete(`operator/merchants/${uuid}`)


export const fetchCustomPaymentTypes = (venueUuid) =>
  stadiumApi.get('/operator/custom_payment_types', {
    params: { venue_uuid: venueUuid },
  })

export const createCustomPaymentType = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.post('operator/custom_payment_types', params)
}

export const updateCustomPaymentType = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.put('operator/custom_payment_types', params)
}

export const deleteCustomPaymentType = (uuid) =>
  stadiumApi.delete(`operator/custom_payment_types/${uuid}`)

export const fetchSalesEvents = (venueUuid) =>
  stadiumApi.get('operator/sales_events', {
    params: {
      venue_uuid: venueUuid,
    },
  })

export const createSalesEvent = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.post('operator/sales_events', params)
}

export const updateSalesEvent = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.put('operator/sales_events', params)
}

export const fetchAvailability = (venueUuid) =>
  stadiumApi.get(`/mobile_web/v1/availability/venues/${venueUuid}`)

export const fetchPriceLevels = (venueUuid) =>
  stadiumApi.get('/external/item_property_overrides', {
    params: { venue_uuid: venueUuid },
  })

export const createSettings = (data) => {
  let params = decamelizeKeys({ data })

  params.data = { settings: [...params.data] }
  return stadiumApi.post('/external/settings', params)
}

export const fetchSettings = () => {
  return stadiumApi.get('/external/settings')
}

export const updatePriceLevel = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.put('/external/item_property_overrides', params)
}

export const createPriceLevel = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.post('/external/item_property_overrides', params)
}

export const fetchSalesEventTypes = (venueUuid) =>
  stadiumApi.get('/external/sales_event_types', {
    params: { venue_uuid: venueUuid },
  })

export const fetchVenues = () => porticoApi.get(`/devices/venues`)

export const fetchMenus = (venueUuid, includeSettings) =>
  stadiumApi.get('/external/menus', {
    params: {
      venue_uuid: venueUuid,
      include_settings: includeSettings,
    },
  })

export const createMenus = (data) => {
  let params = decamelizeKeys({ data })

  params.data = { menus: [...params.data] }

  return stadiumApi.post('/external/menus', params)
}

export const updateMenus = (data) => {
  let params = decamelizeKeys({ data })

  params.data = { menus: [...params.data] }

  return stadiumApi.put('/external/menus', params)
}

export const fetchItems = (venueUuid) =>
  stadiumApi.get('/external/items', {
    params: { venue_uuid: venueUuid },
  })

export const fetchFilteredAndPaginatedItems = ({
  per,
  page,
  searchBy,
  searchFor,
  venueUuid,
}) =>
  stadiumApi.get('/external/items', {
    params: {
      per,
      page,
      sort_by: 'name',
      search_by: searchBy,
      search_for: searchFor,
      venue_uuid: venueUuid,
    },
  })

export const fetchCategories = (venueUuid) =>
  stadiumApi.get('/external/item_categories', {
    params: { venue_uuid: venueUuid },
  })

export const createCategory = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.post('/external/item_categories', params)
}

export const updateCategory = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.put('/external/item_categories', params)
}

export const fetchRevenueCenters = (venueUuid, includeSettings) =>
  stadiumApi.get('external/stands', {
    params: {
      venue_uuid: venueUuid,
      include_settings: includeSettings,
    },
  })

export const createRevenueCenters = (data) => {
  let params = decamelizeKeys({ data })
  params.data = { stands: [...params.data] }

  return stadiumApi.post('/external/stands', params)
}

export const updateRevenueCenters = (data) => {
  let params = decamelizeKeys({ data })

  params.data = { stands: [...params.data] }

  return stadiumApi.put('/external/stands', params)
}

export const createItem = (venueUuid, data) => {
  data.venue_uuid = venueUuid
  let params = decamelizeKeys({ data })

  params.data = { items: [params.data] }

  return stadiumApi.post(
    `/external/items?venue_uuid=${venueUuid}`,
    params
  )
}

export const createSalesEventType = (data) => {
  const params = {
    data,
  }

  return stadiumApi.post('/external/sales_event_types', params)
}

export const updateSalesEventType = (data) => {
  const params = {
    data,
  }

  return stadiumApi.put('/external/sales_event_types', params)
}

export const deleteSalesEventType = (externalRefId) => {
  return stadiumApi.delete(
    `/external/sales_event_types/${externalRefId}`
  )
}

export const removeItem = (uuid) =>
  stadiumApi.delete(`/external/items/${uuid}`)

export const updateItem = (data) => {
  let params = decamelizeKeys({ data })
  params.data = { items: [...params.data] }

  return stadiumApi.put('/external/items/', params)
}

export const updateReportingCategory = (data) => {
  let params = { data: decamelizeKeys(data) }
  return stadiumApi.put('/external/item_categories', params)
}

export const createReportingCategory = (data) => {
  let params = { data: decamelizeKeys(data) }

  return stadiumApi.post('/external/item_categories', params)
}

export const fetchFeatureFlags = (venueUuid, orgName) =>
  stadiumApi.get('/operator/support/settings', {
    params: { venue_uuid: venueUuid, organization_name: orgName },
  })

const api = {
  fetchMerchants,
  createMerchant,
  updateMerchant,
  deleteMerchant,
  fetchCustomPaymentTypes,
  createCustomPaymentType,
  updateCustomPaymentType,
  deleteCustomPaymentType,
  fetchSalesEvents,
  createSalesEvent,
  updateSalesEvent,
  fetchSalesEventTypes,
  createSalesEventType,
  updateSalesEventType,
  deleteSalesEventType,
  createPriceLevel,
  fetchPriceLevels,
  updatePriceLevel,
  fetchItems,
  createItem,
  removeItem,
  updateItem,
  fetchCategories,
  createCategory,
  updateCategory,
  fetchMenus,
  createMenus,
  updateMenus,
  fetchRevenueCenters,
  createRevenueCenters,
  updateRevenueCenters,
  fetchVenues,
  updateReportingCategory,
  createReportingCategory,
  createSettings,
  fetchSettings,
  fetchFilteredAndPaginatedItems,
  fetchFeatureFlags,
}

export default api
